export default {
    wheelSensitivity: 0.3,
    minZoom: 0.1,
    maxZoom: 1,
}